import * as markets from '../actions/markets';
import {LOGOUT} from '../actions/auth';

const initialState = {
  isFetching: false,
  markets: undefined
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOGOUT:
      return initialState;

    case markets.GET_MARKETS_REQUEST:
      return {
        ...state,
        isFetching: true,
      };

    case markets.GET_MARKETS_SUCCESS:
      return {
        isFetching: false,
        markets: action.payload.markets,
        dspMarkets : action.payload.dsp,
        walmartMarkets : action.payload.walmart,
        skaiMarkets: action.payload.skai
      };

    case markets.GET_MARKETS_FAILURE:
      return {
        isFetching: false,
        markets: [],
        dspMarkets: [],
        walmartMarkets: [],
        skaiMarkets: []
      };

    default:
      return state
  }
}